import styled, { keyframes } from "styled-components";
import COLORS from "../../constants/colors";
import FONTS from "../../constants/fonts";


export const LoadingWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
`


const BounceAnimation = keyframes`
  0% { 
    margin-bottom: 0; 
  }

  50% { 
    margin-bottom: 1rem;
  }

  100% { 
    margin-bottom: 0;
  }
  `


export const Dot = styled.div`
  background-color: black;
  border-radius: 50%;
  width: 0.75rem;
  height: 0.75rem;
  margin: 0 0.25rem;
  /*Animation*/
  animation: ${BounceAnimation} 0.5s linear infinite;
  animation-delay: ${(props) => props.delay};
  `


export const WholeWrapper = styled.div`
  padding: 4.8rem 8rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const ShinyGreeting = styled.div`
  font-family: ${FONTS.UbuntuRegular};
  font-size: 4rem;
  line-height: 4.6rem;
  color: #fff;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 18px rgba(0, 150, 198, 0.95);
  margin-top: 6.8rem;
`;

export const AppsHeaderButton = styled.div`
  width: 20.8rem;
  height: 4.8rem;
`;

export const AppsHeaderContainer = styled.div`
  width: 100%;
  padding: 2rem 0;
  margin-top: 2.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 2.2rem;
  line-height: 2.6rem;
  color: #0096c6;
  letter-spacing: 0.1px;
  text-transform: capitalize;
  position: relative;
  margin-bottom: 3.4rem;
  &::after {
    content: "";
    position: absolute;
    width: Calc(100% - 0.4rem);
    height: 1px;
    background: #ffffff33;
    bottom: 0;
    left: 0.2rem;
  }
`;

export const AppsContainerLot = styled.div`
  width: 100%;
  height: 35rem;
  position: relative;
`;

export const AppsContainer = styled.div`
  display: flex;
  align-items: center;
  overflow-x: scroll;
  position: absolute;
  width: Calc(100% + 16rem);
  left: -8rem;
  padding: 0 5rem 2rem 8rem;
`;

// temporary --TO DO-- delete someday
export const shadowAnim = keyframes`
	0% {
		box-shadow: 0px 0px 14px 4px #0096c6;
	}

	25% {
		box-shadow: 0px 0px 56px 6px #0096c6;
	}

	50% {
		box-shadow: 0px 0px 14px 4px #0096c6;
	}
	75% {
		box-shadow: 0px 0px 56px 6px #0096c6;
	}
	100% {
		box-shadow: 0px 0px 14px 4px #0096c6;
	}
`;

export const TempWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: center;
  flex-direction: column;
`;

export const TempHeading = styled.div`
  color: white;
  font-size: 3.2rem;
  line-height: 3.8rem;
  text-shadow: 0px 4px 4px 0px #00000040;
`;

export const TempButton = styled.button`
  color: white;
  padding: 0 5.6rem;
  height: 11.4rem;
  border-radius: 5.7rem;
  background: ${COLORS.primary.oxford};
  box-shadow: 0px 0px 24px 4px #0096c6;
  outline: none;
  border: none;
  font-size: 3rem;
  line-height: 3.4rem;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);
  text-transform: capitalize;
  font-family: ${FONTS.UbuntuBold};
  letter-spacing: 0.1rem;
  margin-top: 4.8rem;
  animation: ${shadowAnim} 3.2s infinite;
  animation-timing-function: ease-in-out;
`;
